<template>
  <div class="sample-detail-additional-info">
    <h3>Additional Information</h3>
    <div class="flex-group multiple-texts">
      <AutoComplete
        :formData="sampleData"
        :tabindex="300"
        :mapping="mappings.Comment"
        :removeOptionsLimit="true"
        store="Comment"
        placeholder="Comment"
        @loadComplete="commentLoadComplete"
      >
        Comment ID
      </AutoComplete>
      <div class="form-field flex-group">
        <p id="severityLevel">
          <span v-if="severity">{{ severity }}</span>
          &nbsp;
        </p>
      </div>
    </div>
    <div class="form-field flex-group form-group top-align">
      <label class="k-textbox-label" for="sampleNumber">Comments</label>
      <textarea @keydown="commentsChange" v-model="sampleData.comments" class="k-textarea" tabindex="302"></textarea>
    </div>
    <div class=" form-field flex-group form-group top-align">
      <label class="k-textbox-label" for="customerComments">Customer Comments</label>
      <p id="customerComments" v-if="sampleData.customerComments">
        <span v-if="sampleData.customerComments">[{{ sampleData.customerComments }}]</span>
        &nbsp;
      </p>
    </div>
    <div class="form-field flex-group form-group top-align">
      <label class="k-textbox-label" for="contactInfo">Contact Information</label>
      <div>
        <p>
          <span class="bold">All Emails:</span>
          &nbsp;{{ appendDefaultEmail(sampleData.email, sampleData.allReportEmails) }}
        </p>
        <p>
          <span class="bold">Good Emails:</span>
          &nbsp;{{ appendDefaultEmail(sampleData.email, sampleData.goodReportEmails) }}
        </p>
        <p>
          <span class="bold">Bad Emails:</span>
          &nbsp;{{ appendDefaultEmail(sampleData.email, sampleData.badReportEmails) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AutoComplete from '../../shared/AutoComplete.vue';
import SampleMixin from '../../shared/SampleMixin';

export default {
  name: 'SampleDetailAdditionalInfo',
  data() {
    return {
      loadComplete: false
    };
  },
  mixins: [SampleMixin],
  props: {
    sampleData: {
      type: Object,
      required: true
    },
    mappings: {
      type: Object,
      required: true
    },
    severity: {
      type: String,
      required: true
    }
  },
  methods: {
    commentsChange() {
      this.sampleData.commentID = null;
    },
    commentLoadComplete(defaultComment) {
      if (defaultComment?.commentID && !this.loadComplete && !this.sampleData.comments) {
        const commentsData = this.$store.getters.getAutoCompleteData('Comment', 'dataSource');
        if (commentsData.length) {
          this.loadComplete = true;
          const comment = commentsData.find(comment => comment.commentID === defaultComment.commentID);

          this.sampleData.comments = comment?.commentText;
        }
      }
    }
  },
  components: {
    AutoComplete
  }
};
</script>
<style scoped>
#contactInfo {
  resize: none;
}
</style>
